var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import classNames from 'classnames';
import ReactResizeDetector from 'react-resize-detector';
function getElementWidthHoc(Wrapper, _a) {
    var _b = _a === void 0 ? {} : _a, className = _b.className;
    return function (props) {
        return (React.createElement("div", { style: { position: 'relative' }, className: classNames(className) },
            React.createElement(ReactResizeDetector, { handleWidth: true }, function (_a) {
                var width = _a.width;
                return React.createElement(Wrapper, __assign({ width: width }, props));
            })));
    };
}
export default getElementWidthHoc;
//# sourceMappingURL=getElementWidthHoc.js.map